import SearchIcon from '../assets/icon_search.svg'
import Chevron from '../assets/chevron.svg'
import {useEffect, useRef, useState} from 'react';
import {PrizesDisplay} from "./PrizesDisplay";
import moment from "moment";
import {getDailyTableName, tableForSpins} from '../helpers/functions';
import {useInViewport} from 'react-in-viewport';
import {clearSearchTable, searchTable} from "../context/actions/userActions";
import {useAPIData} from "../context/hooks/useAPIData";
import {Countdown} from "./Countdown";
import {PrizeAnouncement} from './PrizeAnouncement'

export const TablePrizes = (props) => {
    const data = useAPIData()
    const {raceRef, isFutureRace} = props
    const tableRef = useRef(null)
    const {remainingPrizes, totalAmountLeft, totalPlayers, totalPrizes, start, end, prizeHistory, id, code} = props.data
    const [extended, setExtended] = useState(!props.inactive)
    const [name, setName] = useState('')
    const [playerList, setPlayers] = useState(prizeHistory)
    const [announcePrize, setAnnouncePrize] = useState(false)
    let index = data.activeRaces.map(race => race.id).indexOf(id)
    if(index === -1){
        index = data.oldRaces.map(race => race.id).indexOf(id)
    }
    const searched = data && ((data.activeRaces && data.activeRaces[index] && data.activeRaces[index].searched) || (data.oldRaces && data.oldRaces[index] && data.oldRaces[index].searched))
    const spinsTable = tableForSpins(prizeHistory.length ? prizeHistory[0].items : [])
    const {
        inViewport
    } = useInViewport(
        raceRef,
        {},
        {disconnectOnLeave: false},
        props
    );

    useEffect(() => {
        setName('')
        setPlayers(prizeHistory)
    }, [prizeHistory])

    useEffect(() => {
        setName('')
        return () => {
            setName('')
            clearSearch()
        }
    }, [])

    useEffect(() => {
        if (!searched || searched.length < 1 || ( searched && searched.length === 1 && searched[0].items && searched[0].items.length < 1)) {
            name.length > 0 && data.openPopup()
            return
        }
        if(!props.inactive) {
            setAnnouncePrize(true)
        }
        setPlayers(searched)
    }, [searched])

    const onSubmit = (e) => {
        e.preventDefault()
        searchTable(data.dispatch, id, name, !props.inactive)
    }

    const onChange = (e) => {
        setName(e.target.value)
    }

    const clearSearch = () => {
        setName('')
        setPlayers(prizeHistory)
        setAnnouncePrize(false)
        clearSearchTable(data.dispatch, id)
    }

    return (
        <div className={"card " + (props.isFutureRace ? 'card-future ' : '') + (props.inactive ? 'card-inactive ' : '') + (props.visible ? 'showTerms' : '')}>
            <h2 className="desktop-title">{getDailyTableName(code)}</h2>
            <div className="card-section card-header">
                <div className="card-header-infos">
                    <div className="info">
                        <span>{'Premii rămase'}</span>
                        <div className="withCurrency"><span
                            className="totalAmountLeft">{totalAmountLeft.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' '}</span>
                            <span>{!isFutureRace ? (spinsTable ? 'runde' : 'lei') : ''}</span>
                        </div>
                    </div>
                    <div className="info">
                        <span>{isFutureRace ? 'Începe în' : 'Timp rămas'}</span>
                        <div className="time">{moment(end).isBefore(moment()) ? <span>ÎNCHEIATĂ</span> :
                            <Countdown endDate={isFutureRace ? start : end}/>}</div>
                    </div>
                    <div className="info">
                        <span>{isFutureRace ? 'Număr premii' : 'Calificați azi'}</span>
                        <div className="totalPlayers"><span>{(isFutureRace ? totalPrizes : totalPlayers) + ' '}</span> <span>{isFutureRace ? 'rămase' : 'jucători'}</span></div>
                    </div>
                </div>
            </div>
            {!isFutureRace && <div className="card-section card-searchbar">
                <form onSubmit={onSubmit}>
                    <img className="search-icon" src={SearchIcon} alt="search"/>
                    <input onChange={onChange} placeholder="Introdu email/username" value={name} autoComplete="off"
                           type="text" name="search"/>
                    <div className={"input-clear " + (name.length > 0 ? 'showTerms' : '')}
                         onClick={clearSearch}>&times;</div>
                    <button type="submit">Caută</button>
                </form>
            </div>}
            {!isFutureRace && <div ref={tableRef} className={"card-section card-table " + (extended ? '' : 'card-table-inactive')}>
                <div className="card-row card-data-dropdown-item card-table-header">
                    <div className="card-data card-data-title">Data</div>
                    <div className="card-data card-data-title">Ora</div>
                    <div className="card-data card-data-title">User</div>
                    <div className="card-data card-data-title">Premiu</div>
                </div>
                {inViewport && !announcePrize && playerList && playerList.sort((a, b) => new Date(b.date) - new Date(a.date)).map((race, index) =>
                    <PrizesDisplay key={index} spins={spinsTable} long={playerList.length === 1} keyNr={index} data={race}
                                   showHeader={index !== 0}/>)}
                {inViewport && announcePrize && <PrizeAnouncement remainingPrizes={remainingPrizes} {...searched[0]}/>}

            </div>}
            {!isFutureRace && <div className="dropdown-inactive-card">
                {props.inactive && <div className="dropdown-inactive-card-wrapper" onClick={() => {
                    setExtended(!extended)
                    tableRef.current.scrollTo({
                        top: 0
                    })
                }}>
                    <p>{extended ? 'Ascunde întreaga listă de câștigători' : 'Vezi întreaga listă de câștigători'}</p>
                    <img src={Chevron} style={extended ? {transform: 'rotate(180deg)'} : {}} alt={''}/></div>}
            </div>}
        </div>
    )
}